import { render, staticRenderFns } from "./PixOrderCreated.vue?vue&type=template&id=6b6750ea&"
import script from "./PixOrderCreated.vue?vue&type=script&lang=js&"
export * from "./PixOrderCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6750ea')) {
      api.createRecord('6b6750ea', component.options)
    } else {
      api.reload('6b6750ea', component.options)
    }
    module.hot.accept("./PixOrderCreated.vue?vue&type=template&id=6b6750ea&", function () {
      api.rerender('6b6750ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/OrderCreated/PixOrderCreated.vue"
export default component.exports